import { render, staticRenderFns } from "./ExtractAdd.vue?vue&type=template&id=72a942a6"
import script from "./ExtractAdd.vue?vue&type=script&lang=js"
export * from "./ExtractAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports